
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-check-circle",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-check-circle"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 11.08V12a10 10 0 11-5.93-9.14"}}),_c('path',{attrs:{"d":"M22 4L12 14.01l-3-3"}})])
          )
        }
      }
    